<template>
    <v-dialog v-model="dialog" max-width="600px" persistent scrollable no-click-animation>
        <v-card tile>
            <v-card-title>
                <div class="title-dialog">
                    Instructions / Instrucciones
                </div>
                <v-spacer />
                <v-btn icon color="accent" large @click="hide">
                    <v-icon large>mdi-close-circle-outline</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                In this application, you can create your expense reports, upload the corresponding receipts, classify
                them, and provide your bank details so that, if approved, they can be reimbursed.
                For proper operation and to simplify the creation process, we recommend keeping the following
                considerations in mind:
                <li>
                    1. When creating the expense report, you will only be asked for the exchange rate (if not
                    applicable, enter 1), the date, a description of the task or work that generated the report, and
                    your bank details for reimbursement (bank, account number, ID, and contact email).
                </li>
                <li>
                    2. A code will be automatically assigned to the expense report and saved.
                </li>
                <li>
                    3. You can then immediately start uploading your expenses using the (+) button. (You do not need to
                    upload everything at once; you can continue adding expenses later.)
                </li>
                <li>
                    4. You must indicate the type of receipt and the accounting account to which you estimate each
                    expense should be assigned.
                </li>
                <li>
                    5. Have your receipt images ready in image format (.jpg) or as a screenshot — not in PDF format.
                </li>
                <li>
                    6. We recommend saving the images with the receipt number to make them easier to identify when
                    uploading.
                </li>
                <li>
                    7. Once finished, using the download option, you can create a .pdf file of your report to send to
                    the appropriate person.
                </li>

                <v-divider class="my-3" />

                En esta aplicación podrá crear sus reportes de gastos, subir los comprobantes correspondientes,
                clasificarlos e ingresar sus datos bancarios para que, en caso de ser aprobados, se le realice el
                reembolso.
                Para un correcto funcionamiento y un proceso de creación más sencillo, le recomendamos tener en cuenta
                las siguientes consideraciones:

                <li>
                    1. Al crear el reporte de gastos, solo se le solicitará el tipo de cambio (si no aplica, ingrese 1),
                    la fecha, la descripción de la gestión o trabajo que originó el reporte y sus datos bancarios para
                    el reembolso (banco, número de cuenta, DNI y correo electrónico de contacto).
                </li>
                <li>
                    2. Automáticamente se asignará un código al reporte de gastos, el cual quedará guardado.
                </li>
                <li>
                    3. Luego, podrá comenzar a subir sus distintos gastos mediante el botón (+). (No es necesario
                    ingresar todo de una vez; puede continuar agregando gastos cuando lo estime conveniente.)
                </li>
                <li>
                    4. Debe indicar el tipo de comprobante y la cuenta contable a la cual considera que debe asignarse
                    cada gasto.
                </li>
                <li>
                    5. Tenga listas las imágenes de sus comprobantes en formato de imagen (.jpg) o como captura de
                    pantalla, no en formato PDF.
                </li>
                <li>
                    6. Le recomendamos guardar las imágenes con el número de comprobante para facilitar su
                    identificación al momento de cargarlas.
                </li>
                <li>
                    7. Finalmente, utilizando la opción de descarga, podrá generar un archivo .pdf con su rendición para
                    enviarlo a quien corresponda.
                </li>
            </v-card-text>
            <v-card-actions class="pa-0">
                <v-btn class="normal-btn" color="primary" depressed x-large block @click="hide">
                    Understood / Entendido
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import { mapMutations, mapState } from 'vuex'
import Axios from "@/utils/Axios";

export default {
    name: "ExpenseReportTipsDialog",
    data() {
        return {
            dialog: false,
        }
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.$emit('hide')
        },
    },
}
</script>

<style scoped></style>
